import { useQuery } from '@tanstack/react-query';
import { getPublicTenantConfig } from './api';
import { DEFAULT_COIN_LABEL } from './coin-label';

/**
 * The tenant's coin display name (e.g. "UPCoin"), for every till surface that
 * names the coin wallet.
 *
 * Reads the public `/tenant/config` endpoint under the SAME react-query key the
 * sidebar already uses, so this costs no extra request — the entry is warm
 * before the POS page paints. Falls back to "Coins" while loading or if the
 * call fails, which keeps the till usable when branding is unreachable.
 */
export function useCoinLabel(): string {
  const q = useQuery({
    queryKey: ['public-tenant-config'],
    queryFn: getPublicTenantConfig,
    staleTime: 60_000,
    retry: false,
  });
  return q.data?.coinLabel || DEFAULT_COIN_LABEL;
}
